export default __webpack_public_path__ + "static/media/_wales.588721cd.ico";